/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Retainer_Bugs_Desc4Inputs */

const en_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Production bugs triaged and fixed first, with regression tests attached.`)
};

const ar_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أخطاء الإنتاج تُفرَز وتُعالَج أولا، مع اختبارات انحدار مرفقة.`)
};

const bn_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাকশন বাগ আগে বাছাই আর ঠিক করা, রিগ্রেশন টেস্টসহ।`)
};

const de_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktionsfehler werden zuerst triagiert und behoben, mit Regressionstests im Anhang.`)
};

const es_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errores de producción clasificados y corregidos primero, con pruebas de regresión incluidas.`)
};

const fr_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugs de production triés et corrigés en premier, avec tests de régression joints.`)
};

const pt_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erros de produção triados e corrigidos primeiro, com testes de regressão incluídos.`)
};

const zh_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产缺陷先分诊先修，每个都附回归测试。`)
};

const tr_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üretim hataları önce triyajlanıp düzeltilir, regresyon testleri ekli.`)
};

const ru_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прод-баги триажатся и чинятся в первую очередь, с приложенными регрессионными тестами.`)
};

const pl_svc_retainer_bugs_desc4 = /** @type {(inputs: Svc_Retainer_Bugs_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błędy produkcyjne triażowane i naprawiane w pierwszej kolejności, z dołączonymi testami regresji.`)
};

/**
* | output |
* | --- |
* | "Production bugs triaged and fixed first, with regression tests attached." |
*
* @param {Svc_Retainer_Bugs_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_retainer_bugs_desc4 = /** @type {((inputs?: Svc_Retainer_Bugs_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Retainer_Bugs_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_retainer_bugs_desc4(inputs)
	if (locale === "bn") return bn_svc_retainer_bugs_desc4(inputs)
	if (locale === "de") return de_svc_retainer_bugs_desc4(inputs)
	if (locale === "es") return es_svc_retainer_bugs_desc4(inputs)
	if (locale === "fr") return fr_svc_retainer_bugs_desc4(inputs)
	if (locale === "pt") return pt_svc_retainer_bugs_desc4(inputs)
	if (locale === "zh") return zh_svc_retainer_bugs_desc4(inputs)
	if (locale === "tr") return tr_svc_retainer_bugs_desc4(inputs)
	if (locale === "ru") return ru_svc_retainer_bugs_desc4(inputs)
	if (locale === "pl") return pl_svc_retainer_bugs_desc4(inputs)
	return en_svc_retainer_bugs_desc4(inputs)
});
export { svc_retainer_bugs_desc4 as "svc_retainer_BUGS_desc" }